import Accordion from '../lib/accordion';

export default class SiteHeader {

  init() {
    this.form = this.outlets.form;
    this.currentController = null;
    this.selector = '.block-taxonomy-term__results-body'; // Change to your content selector

    this.form.addEventListener('submit', (e) => this.onSubmit(e));
    this.form.addEventListener('change', () => this.form.dispatchEvent(new Event('submit', { cancelable: true })));
    window.addEventListener('popstate', (e) => this.onPopState(e));

    if (this.outlets.filter) {
      this.outlets.filter.forEach((filter) => {
        new Accordion(filter.node, '.block-taxonomy-term__filter-taxonomy-inner');

        filter.node.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            this.updateCount(filter);
          });
        });
      });
    }

    this.outlets.clearAll.forEach((clearAll) => {
      clearAll.addEventListener('click', () => {
        this.clearForm(this.outlets.form);
        this.outlets.form.submit();
      });
    });

    // this.outlets.sortSelect.addEventListener('change', (e) => {
    //   this.outlets.sortField.value = this.outlets.sortSelect.value;
    //   this.outlets.form.submit();
    // });
  }

  clearForm(formElement) {
    if (!formElement) return;

    const elements = formElement.elements;

    for (let i = 0; i < elements.length; i++) {
      const field = elements[i];
      const type = field.type;

      switch (type) {
        case 'text':
        case 'password':
        case 'textarea':
        case 'email':
        case 'number':
        case 'url':
        case 'tel':
        case 'search':
        case 'date':
          field.value = '';
          break;

        case 'checkbox':
        case 'radio':
          field.checked = false;
          break;

        case 'select-one':
        case 'select-multiple':
          field.selectedIndex = -1;
          break;

        default:
          field.value = '';
      }
    }
  }

  updateCount(filter) {
    const checked = Array.from(filter.node.querySelectorAll('input[type="checkbox"]:checked')).length;
    filter.count.textContent = (checked > 0) ? `(${checked})` : '';
  }

  async onSubmit(e) {
    e.preventDefault();
    await this.loadFormResults(true);
  }

  async onPopState(event) {
    const url = event.state?.url || location.href;
    await this.loadURL(url, false);
  }

  async loadFormResults(pushHistory = false) {
    if (!this.form) return;

    if (this.currentController) {
      this.currentController.abort();
    }
    this.currentController = new AbortController();

    const formData = new FormData(this.form);
    const method = this.form.method.toUpperCase();

    let url = this.form.action;
    const fetchOptions = {
      method,
      signal: this.currentController.signal,
    };

    if (method === 'GET') {
      const params = new URLSearchParams(formData).toString();
      url += (url.includes('?') ? '&' : '?') + params;
    } else {
      fetchOptions.body = formData;
    }

    await this.loadURL(url, pushHistory, fetchOptions);
  }

  async loadURL(url, pushHistory = false, fetchOptions = { method: 'GET' }) {
    try {
      const response = await fetch(url, fetchOptions);
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Server error:\n\n${text}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newEl = doc.querySelector(this.selector);
      const oldEl = document.querySelector(this.selector);

      if (newEl && oldEl) {
        oldEl.replaceWith(newEl);
      }

      if (pushHistory) {
        history.replaceState({ url }, '', url);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('AJAX request failed:', error);
        alert(`Error:\n\n${error.message}`);
      }
    }
  }

}
